import { render, staticRenderFns } from "./LanguageAndCasualSettings.vue?vue&type=template&id=76a391d6&"
import script from "./LanguageAndCasualSettings.vue?vue&type=script&lang=js&"
export * from "./LanguageAndCasualSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports